module.exports = __webpack_public_path__ + "static/media/ppa-mobile-screens.1e0e890a.png";